import { render, staticRenderFns } from "./BannerContent.vue?vue&type=template&id=628baaa1&scoped=true&"
import script from "./BannerContent.vue?vue&type=script&lang=js&"
export * from "./BannerContent.vue?vue&type=script&lang=js&"
import style0 from "./BannerContent.vue?vue&type=style&index=0&id=628baaa1&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628baaa1",
  null
  
)

export default component.exports